(function () {
  'use strict';

  if (window.__swiperRegistryInitialized) return;
  window.__swiperRegistryInitialized = true;

  // Map: HTMLElement container -> Swiper instance
  var _registry = new Map();

  function _safeDestroy(instance) {
    if (!instance) return;
    try {
      instance.destroy(true, true);
    } catch (_) {}

    // Swiper 11 does not always null internal DOM references after destroy().
    // Null them explicitly so GC can collect detached DOM nodes.
    try {
      instance.slides = null;
      instance.wrapperEl = null;
      instance.el = null;
    } catch (_) {}
  }

  function _unregisterEl(el) {
    if (_registry.has(el)) {
      _safeDestroy(_registry.get(el));
      _registry.delete(el);
    }
  }

  function _destroyOnElement(el) {
    if (!el) return;

    // Strategy A — registry (instances created via createTrackedSwiper or register())
    if (_registry.has(el)) {
      _safeDestroy(_registry.get(el));
      _registry.delete(el);
      return;
    }

    // Strategy B — el.swiper (Swiper 6-11 sets this automatically on every container)
    if (el.swiper) {
      // Only destroy if the removed element is the instance's actual container.
      // This prevents accidentally destroying the wrong Swiper when internal nodes churn.
      var inst = el.swiper;
      if (inst && inst.el === el) {
        _safeDestroy(inst);
      }
    }
  }

  function _destroyInSubtree(root) {
    _destroyOnElement(root);

    if (root && typeof root.querySelectorAll === 'function') {
      var children = root.querySelectorAll('*');
      for (var i = 0; i < children.length; i++) {
        _destroyOnElement(children[i]);
      }
    }
  }

  // Core fix: destroy Swipers as soon as their containers are removed from the DOM,
  // before the next GC pass, to prevent detached node heap retention.
  new MutationObserver(function (mutations) {
    for (var m = 0; m < mutations.length; m++) {
      var removed = mutations[m].removedNodes;
      for (var n = 0; n < removed.length; n++) {
        if (removed[n].nodeType === 1 /* ELEMENT_NODE */) {
          _destroyInSubtree(removed[n]);
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  // Public registry API
  window.__swiperRegistry = {
    register: function (el, instance) {
      if (_registry.has(el)) _safeDestroy(_registry.get(el));
      _registry.set(el, instance);
    },
    unregister: _unregisterEl,
    destroyAll: function () {
      _registry.forEach(_safeDestroy);
      _registry.clear();
    },
    destroyDetached: function () {
      _registry.forEach(function (instance, el) {
        if (!document.documentElement.contains(el)) {
          _safeDestroy(instance);
          _registry.delete(el);
        }
      });
    },
    get size() {
      return _registry.size;
    },
  };

  // Drop-in replacement for `new Swiper(...)`
  window.createTrackedSwiper = function (elOrSelector, options) {
    var el =
      typeof elOrSelector === 'string' ? document.querySelector(elOrSelector) : elOrSelector;
    if (!el) return null;

    if (_registry.has(el)) _safeDestroy(_registry.get(el));

    var instance = new Swiper(el, options);
    _registry.set(el, instance);
    return instance;
  };
}());

